import React from 'react'
import { withStyles, Typography, TextField } from '@material-ui/core'

const styles = {
    subHeader: {
        color: '#878787',
        flex: 1
    },
    containerLabelsFullWidth: {
        display: 'flex'
    },
    formFields: {
        display: 'inline',
        margin: '0 0 10px 0px',
        height: '45px',
        marginBottom: '7px',
        marginTop: '7px',
    },
};

const noop = () => { };

/**
 * @typedef {Object} ReactTextFieldProps
 * @property {Function=} ReactTextFieldProps.changeHandler
 * @property {number=} ReactTextFieldProps.inputLength
 * @property {string} ReactTextFieldProps.valueString
 */

/** @param {import('@material-ui/core').OutlinedTextFieldProps & ReactTextFieldProps} param0 */
const ReactTextField = ({
    changeHandler = noop,
    classes,
    fieldClass,
    inputLength = 0,
    label,
    labelClass,
    multiline = false,
    placeholder,
    rows = 0,
    value,
    subHeader,
    subHeaderClass,
    valueString,
    ...other
}) => {
    return (
        <>
            <div className={[classes.containerLabelsFullWidth, labelClass].join(' ')}>
                <Typography
                    className={[subHeaderClass, classes.subHeader].join(' ')}
                    color="textSecondary"
                >
                    {label}
                </Typography>
            </div>
            <TextField
                {...other}
                variant="outlined"
                className={[fieldClass, classes.formFields].join(' ')}
                placeholder={placeholder}
                onChange={({ target: { value } }) => {
                    changeHandler(valueString, value);
                }}
                value={value}
                fullWidth
                multiline={multiline}
                rows={rows}
                margin="normal"
                InputLabelProps={{
                    'aria-label': 'Name',
                }}
                inputProps={{
                    maxLength: inputLength
                }}
            />
        </>
    )
}

export default withStyles(styles)(ReactTextField)